import AdminAuth from "./components/AdminAuth";

const Admin = () => {
  return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4">
          <AdminAuth />
        </div>
      </div>
  );
};

export default Admin;
